import Dexie from 'dexie';

export const db = new Dexie('PhysioVideoDB');

db.version(1).stores({
  videos: 'id, title, bodyPart, equipment, difficulty, condition'
});